import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Error occurs during caption generation',
  name: 'caption_generation_failed',
  params: [
    {
      description: 'The id of the video',
      name: 'video_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Type of error that occurred during generation',
      name: 'error_type',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
